import { getJsonRequest } from '@chilecompra/react-kit/requests'
import { REACT_APP_API_BASE_URL } from '../config/settings/environment'
import factoryAuthService from '../modules/requests/services'

/**
 * Search for a Provider
 */
export const searchProviderWithType = factoryAuthService(({ text, idType }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/elastic/organization/search/${idType}/${text}`)
)
/**
 * Search for a Provider
 */
export const searchProvider = factoryAuthService(({ term }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/elastic/organization/search/${term}`)
)
/**
 * Get the entire Provider's buyers list
 */
export const getAllProvidersBuyer = factoryAuthService(({ year, buyers, sectorId, processId }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/suppliertransacts/list/${year}/${processId}/${sectorId}/${buyers}`)
)
/**
 * Get the entire Provider's list
 */
export const getAllProviders = factoryAuthService(() =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/elastic/organization/all`)
)
/**
 * Get the supplier's detail
 */
export const getAllSupplierDetail = factoryAuthService(({ year, buyers, sectorId, dni, idProcess }) =>
  getJsonRequest(
    `${REACT_APP_API_BASE_URL}/v1/suppliertransacts/details/${year}/${idProcess}/${sectorId}/${buyers}/${dni}`
  )
)
/**
 * Get the entire ProviderFramework's list
 */
export const getAllProvidersFramework = factoryAuthService(({ year, idFrameworkAgreement }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/suppliersframework/list/${year}/${idFrameworkAgreement}`)
)
